module.exports = __webpack_public_path__ + "static/media/Strip.7fecfcea.jpg";